import { OptimizelyProvider } from '@optimizely/react-sdk';
import React, { useMemo } from 'react';

import optimizely from 'util/optimizely';
import getOptimizelyAttributes from 'util/optimizely/getAttributes';

// Queried data should try to consolidate fetching with the other top-level query
const OptimizelyWithAttributesProvider: React.FC<{ uuid: string; children: React.ReactNode }> = ({
  uuid,
  children,
}) => {
  const attributes = useMemo(
    () => ({
      ...getOptimizelyAttributes(window.location.search, optimizely.user.attributes),
    }),
    []
  );

  return (
    <OptimizelyProvider
      optimizely={optimizely}
      user={{
        id: uuid,
        attributes,
      }}
    >
      {children}
    </OptimizelyProvider>
  );
};

export default OptimizelyWithAttributesProvider;
